module.exports = __webpack_public_path__ + "img/loader.56b27106.svg";